;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "62RuQDcfMx"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var $this = jQuery(this);
  function setPaddingBG() {
      var $dom = $this.find('.lh-heading');
      if($dom.hasClass('lh-check-lazy')) return;
      var img_bg = $dom.css('background-image');
      if(img_bg.includes('url')){
        var url = img_bg.match(/\(\"?\'?([^\"\'\(]+)\"?\'?\)/);
        if(url)
        {
          var img = new Image();
          img.onload = function() {
            var pb = (this.height / this.width * 100) + "%";
            $dom.css({
              'height': 0,
              'padding-bottom': pb
            });
            window.LAYOUTHUB_LIVE && $dom.addClass('lh-check-lazy');
            $dom.hasClass('lh-lazy-loaded') && $dom.addClass('lh-check-lazy');
          }
          img.src = url[1];
        }
      }
  };
  var count = 0;
  function animateImg(event) {
      count++;
      if(count % 15 != 0) return;
      var w_top   = $(window).scrollTop(),
      __this      = $(event.currentTarget) ,
      _this_w     = __this.width(),
      _ratio      = _this_w / 20,
      _offset_l   = __this.offset().left,
      _offset_t   = __this.offset().top,
      _m_x        = event.originalEvent.pageX,
      _m_y        = event.originalEvent.pageY
      _x_new      = (_offset_l - _m_x) / _ratio,
      _y_new      = (_offset_t - _m_y) / _ratio;
      __this.find('.lh-content-main').css({'top': _y_new, 'left': _x_new});
  }
  function setOrigin(event){
    var __this  = $(event.currentTarget),
    img         = __this.find('.lh-content-main');
    img.removeAttr('style');
  }

  $(window).resize(function(){
    setPaddingBG();
    var w_w = $(window).width();
    var item = $this.find('.lh-heading');
    if(w_w >= 1200){
      if(!item.hasClass('lh-added-event')){
        item.addClass('lh-added-event');
        item.mousemove(animateImg);
        item.mouseleave(setOrigin);
      }
    }else{
      item.unbind();
      item.removeClass('lh-added-event');
    }
  }).trigger('resize');
 };						cb.bind($('section[data-section-id="62RuQDcfMx"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="62RuQDcfMx"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/DB0n6ewo4aLVZHrR/content/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "e8q96eaqgbp"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="e8q96eaqgbp"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/67h0YzMovFVQHwbT/term-privacy/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "fqy5uyo8uls"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="fqy5uyo8uls"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWFyLS0yMDIx/NjE1Mjc3MDI3/release-3-2021/pages/dYquXFtvam68ni4E/section/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "5xct58vj91n"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="5xct58vj91n"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/67h0YzMovFVQHwbT/term-privacy/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "yr44mamzrdj"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  let _this = jQuery(this);
  let content = _this.find('.lh-contents');
  (section.settings.style != '3') && _this.find('.lh-item').each(function(){
    let _ = jQuery(this);
    _.find('button').click(function(){
      if(content.hasClass('lh-loading')) return;
      content.addClass('lh-loading');
      _.toggleClass('active');
      _.find('.lh-item__content').slideToggle(200, function(){
        content.removeClass('lh-loading');
      });
      if(section.settings.style == '2'){
        //let sib = _.siblings('.active');
        let sib = content.find('.lh-item.active').not(_);
        sib.removeClass('active');
        sib.find('.lh-item__content').slideUp(200);
      }
    });
  });
 };						cb.bind($('section[data-section-id="yr44mamzrdj"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="yr44mamzrdj"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/9Mr4wymCTgDPN1VJ/faq-1/",						settings: {"style":"1"}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});